import {gsap} from "gsap";
import {XwaysHoarder2Statics} from "../XwaysHoarder2Statics";
import {XW2GameMode, XwaysHoarder2} from "../XwaysHoarder2";
import {
    SimpleReelModelEventData,
    SimpleReelModelState,
    SimpleReelModelSymbolData
} from "../../core/reel/simplereel/SimpleReelModel";
import {SimplePresentation, SimplePresentationRunnerController} from "../SimplePresentationRunner";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {XwaysHoarder2Sound} from "../sound/XwaysHoarder2Sound";
import {BasicSymbol, SymbolStates} from "../reels/symbols/BasicSymbol";
import {LTSymbol} from "../reels/symbols/LTSymbol";


export class NormalStop implements SimplePresentation {
    name: string = "NormalStop";
    private stoppedReels: boolean[];
    private reelStopAnimation: gsap.core.Timeline[];
    private allReelsStopped: boolean;
    private tlComplete: boolean;
    //private bouncedReels:boolean[];
    private tl: gsap.core.Timeline;
    private _scatterCount: number = 0;
    private skipped: boolean = false;
    private anticipationStarted: boolean = false;

    constructor() {
    }

    shouldRun(): boolean {
        return true; //(!XwaysHoarder2.model.data.currentFSLevel || XwaysHoarder2.model.data.currentFSLevel < 4);
    }

    public start(flowStateController: SimplePresentationRunnerController) {
        this.allReelsStopped = false;
        this.tlComplete = false;
        this.skipped = false;
        this.anticipationStarted = false;

        //debugger;

        flowStateController.setSkipCallback(() => this.skip(flowStateController))
        this.stoppedReels = [];
        //this.bouncedReels = [];

        for (let i: number = 0; i < XwaysHoarder2Statics.NR_OF_REELS; i++) {
            this.stoppedReels.push(false);
            //this.bouncedReels.push(false);
        }

        this.tl = gsap.timeline({paused: true, onComplete: () => this.presentationComplete(flowStateController)});

        this.createAllAnimations(flowStateController);

        let jurPadding = 0;
        if (XwaysHoarder2.model.data.mode == GameMode.NORMAL) {
            this.assembleAllAnimations(0);
            jurPadding = XwaysHoarder2.gameFlowController.calculatePaddingDuration(this.tl.totalDuration());
            this.tl.shiftChildren(jurPadding, true);
        } else {
            this.assembleAllAnimations(0);
        }

        this.tl.play(0);


    }

    private createAllAnimations(controller: SimplePresentationRunnerController) {
        this.reelStopAnimation = [];

        for (let i: number = 0; i < XwaysHoarder2Statics.NR_OF_REELS; i++) {
            const reelData = JSON.parse(JSON.stringify(XwaysHoarder2.model.stopReels[i]));
            const stopAnim = XwaysHoarder2.reelView.reels[i].model.stop(reelData).pause(0);

            this.reelStopAnimation.push(stopAnim);

            XwaysHoarder2.reelView.reels[i].model.events?.once(SimpleReelModelState.STOPPED, (data: SimpleReelModelEventData) => this.onReelStop(data, controller));
            XwaysHoarder2.reelView.reels[i].model.events?.once(SimpleReelModelState.BOUNCE, (data: SimpleReelModelEventData) => this.onReelBounce(data));
        }

    }

    private skip(controller: SimplePresentationRunnerController): void {
        controller.setSkipCallback();
        const currentTime = this.tl.time();
        this.skipped = true;


        const stopsToStagger = [];
        for (let i: number = 0; i < this.reelStopAnimation.length; i++) {
            const childStartTime = this.reelStopAnimation[i].startTime();
            if (childStartTime >= currentTime) {
                this.tl.remove(this.reelStopAnimation[i]);
                this.reelStopAnimation[i].pause(0);

                stopsToStagger.push(i);
            }
        }

        let i: number = 0;
        let stopTime = currentTime + XwaysHoarder2Statics.reelStopDelayQuickStop;
        for (let index of stopsToStagger) {
            this.tl.add(this.reelStopAnimation[index].play(0), stopTime);
            i++;
        }
    }

    private assembleAllAnimations(jurPadding: number = 0) {
        let jurPaddingPerReel = jurPadding * 0.17;

        //Assemble animation
        const isFastSpin: boolean = XwaysHoarder2.apiPlugin.settings.get(APISetting.FAST_SPIN, false);
        let value = isFastSpin ? XwaysHoarder2Statics.reelStopDelayFastSpin : XwaysHoarder2Statics.reelStopDelay;
        let reelDelays = [
            value, //3
            value, //3
            value, //4
            value, //4
            value, //5
            value  //6
        ];

        let stagger = 0;
        let anticipationCounter: number = 0;

        let additionalDelays: number[] = [0, 0, 0, 0, 0, 0];
        if (XwaysHoarder2.model.gameData.reels[0].includes("LT")) {
            for (let i = 1; i < 6; i++)
                additionalDelays[i] = 0.6;
        }
        if (XwaysHoarder2.model.gameData.reels[0].includes("LTX")) {
            const stickyCount = XwaysHoarder2.model.gameData.reels
                .reduce((a, b) => a.concat(b), [])
                .filter((sym) => sym == "XW" || sym == "XS").length;
            const stopDelay = stickyCount < 5 ? 0.25 : 0.35;
            for (let i = 1; i < 6; i++)
                additionalDelays[i] = stopDelay;
        }

        for (let reel: number = 0; reel < this.reelStopAnimation.length; reel++) {
            let defaultDelay = reelDelays[reel];
            let defaultStagger = defaultDelay + jurPaddingPerReel;

            //Reel stop
            let endTimeStagger: number;
            let currentReelNo: number = JSON.parse(JSON.stringify(reel));
            let anticipationDelay: number = 0;

            if (XwaysHoarder2.model.data.mode == GameMode.NORMAL &&
                reel > 0 && reel < 4 &&
                XwaysHoarder2.model.reels[reel - 1].some((sym) => sym == "SC") &&
                !XwaysHoarder2.model.scatterAnticipationReels[reel]) {
                additionalDelays[reel] = 0.5;
            }

            if ((XwaysHoarder2.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "FREESPIN_LEVEL4" || XwaysHoarder2.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "FREESPIN_LEVEL5") && XwaysHoarder2.model.gameData.mode === "NORMAL") {
                additionalDelays[5] = 1;
            }

            if (currentReelNo <= 5 && XwaysHoarder2.model.scatterAnticipationReels[currentReelNo]) {
                anticipationCounter++;
                anticipationDelay += isFastSpin ? XwaysHoarder2Statics.SCATTER_ANTICIPATION_DELAY_FAST : XwaysHoarder2Statics.SCATTER_ANTICIPATION_DELAY_NORMAL;
                //anticipationDelay *= anticipationCounter;
            }
            if (isFastSpin) {
                endTimeStagger = reel !== 0 ? 0.04 : 0;
                endTimeStagger += anticipationDelay + additionalDelays[reel];
                this.tl.add(this.reelStopAnimation[reel].play(0), `<${endTimeStagger}`);
            } else {
                endTimeStagger = reel !== 0 ? stagger - this.reelStopAnimation[reel].duration() : 0;
                endTimeStagger += anticipationDelay + additionalDelays[reel];
                this.tl.add(this.reelStopAnimation[reel].play(0), `>${endTimeStagger}`);
            }

            stagger = defaultStagger;
        }
    }

    private presentationComplete(cont: SimplePresentationRunnerController) {
        this.tlComplete = true;
        this.completePresentation(cont);
    }

    private onReelBounce(data: SimpleReelModelEventData) {
        //this.bouncedReels[data.reel] = true;
        // console.log("bounce reel", data.reel);


        for (let symbolData of XwaysHoarder2.reelView.reels[data.reel].model.symbols) {
            if (XwaysHoarder2Statics.specialSymbols.includes(symbolData.name)) {
                if (symbolData.reelPosition > -1 && symbolData.reelPosition < 3) {
                    (<BasicSymbol>symbolData.positionable).getStateAnimation(SymbolStates.LANDING);
                } else if ((symbolData.reelPosition === -1) || (symbolData.reelPosition === 3)) {
                    (<BasicSymbol>symbolData.positionable).getStateAnimation(SymbolStates.NORMAL);
                }
            } else {
                if (symbolData.reelPosition > -2 && symbolData.reelPosition < 4) {
                    (<BasicSymbol>symbolData.positionable).getStateAnimation(SymbolStates.LANDING);
                }
            }
        }

        if (data.reel < 5) {
            if (XwaysHoarder2.model.scatterAnticipationReels[data.reel + 1] && !this.skipped) {
                this.anticipationStarted = true;
                XwaysHoarder2.anticipationView.startAnticipationOnNextReel(data.reel + 1);
            }

        }
        if (data.reel === 0 && (XwaysHoarder2.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "FREESPIN_LEVEL4" || XwaysHoarder2.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "FREESPIN_LEVEL5") && XwaysHoarder2.model.gameData.mode === "NORMAL") {
            XwaysHoarder2.anticipationView.playPlunderSpinAttention();
        }
        if (XwaysHoarder2.model.scatterAnticipationReels[data.reel]) {
            XwaysHoarder2.anticipationView.stopCurrentReelAnticipation(data.reel);
        }

        if (data.reel === 5) {

            if(XwaysHoarder2.model.data.nextMode === XW2GameMode.NORMAL) {
                XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.RESPIN_SYMBOL_LANDING);
            }
            XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.REELS_SPINNING);
            if (XwaysHoarder2.anticipationView.islastReelActive) {
                XwaysHoarder2.anticipationView.stopPlunderSpinAttention();
            }

            if (XwaysHoarder2.model.data.thisRespinIsTheLastReSpinReSpin && !XwaysHoarder2.model.data.reSpinTriggeredByAnotherLoot) {

                XwaysHoarder2Sound.fadeInPreviousMusic(250, 250);
                /*XwaysHoarder2Sound.switchMusic({name: XwaysHoarder2Sound.MAIN_GAME_MUSIC}, {
                    name: XwaysHoarder2Sound.MAIN_GAME_MUSIC,
                    from: 0,
                    to: 1,
                    duration: 500
                });*/
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.RESPIN_MUSIC_ENDS);
            }
        }
        if (!this.checkReelIsStacked(data.reel)) {
            XwaysHoarder2Sound.playLandingSound(data.reel);
        }
        if (XwaysHoarder2.model.scatterLandedPos[data.reel] > -1 && XwaysHoarder2.reelView.reels[data.reel].model.scatterArray.length === 0) {
            this._scatterCount++;     //acknowledge respin round, already sticky sc/ssc
            if (this._scatterCount === 1) {
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.SCATTER_LANDING_1);
            } else if (this._scatterCount === 2) {
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.SCATTER_LANDING_2);
            } else if (this._scatterCount >= 3) {
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.SCATTER_LANDING_3);
            }
        }
        //must play at last reel
        if (XwaysHoarder2.model.totalScatterLanded >= 3 && data.reel === 5 && !XwaysHoarder2Sound.SCATTER_WIN_ALREADY_PLAYED) {
            XwaysHoarder2Sound.SCATTER_WIN_ALREADY_PLAYED = true;
            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.LAST_REEL_LANDING_SCATTER_WIN);
        }
    }

    private onReelStop(data: SimpleReelModelEventData, controller: SimplePresentationRunnerController) {
        // console.log("stopped reel", data.reel);
        this.stoppedReels[data.reel] = true;
        if ((this.stoppedReels).every(value => value)) {

            this.allReelsStopped = true;
            this.completePresentation(controller);
            /* if (XwaysHoarder2.model.scatterAnticipationReels.includes(true)) {
                 XwaysHoarder2.model.scatterLandedPos.forEach((symPos: number, reelIndex: number) => {
                     if (symPos > -1) {
                         let scatterSym: ScatterSymbol = <ScatterSymbol>XwaysHoarder2.reelView.reels[reelIndex].model.getVisibleSymbolAt(symPos).positionable;
                         if (XwaysHoarder2.reelView.reels[reelIndex].model.scatterArray.length === 0) {//in respin scatters might already be sticky
                             scatterSym.endScatterLoop();
                         }
                     }
                 });
             }*/
        }
    }

    private completePresentation(controller: SimplePresentationRunnerController) {
        if (this.tlComplete && this.allReelsStopped) {
            this._scatterCount = 0;
            XwaysHoarder2Statics.previousReelsAfterCollapse = JSON.parse(JSON.stringify(XwaysHoarder2.model.gameData.reelsAfterCollapse));
            if (XwaysHoarder2.model.data.mode === GameMode.FREESPIN || XwaysHoarder2.model.data.mode === XW2GameMode.SUPER_FREESPIN || XwaysHoarder2.model.gameData.thisRespinIsTheLastReSpinReSpin) {
                [0, 1, 2, 3, 4, 5].forEach((reelNo: number) => {
                    XwaysHoarder2.reelView.reels[reelNo].model.moveStickyXSBack();
                    XwaysHoarder2.reelView.reels[reelNo].model.moveStickyXWBack();
                    XwaysHoarder2.reelView.reels[reelNo].model.moveStickySCBack();

                    //  console.log("Hello", XwaysHoarder2.reelView.reels[reelNo].model.symbols);
                })
            }

            if (XwaysHoarder2.model.reels[0].includes("LT")) {
                const ltReelPos: number = XwaysHoarder2.model.reels[0].indexOf("LT");
                const LtsymData: SimpleReelModelSymbolData = XwaysHoarder2.reelView.reels[0].model.getVisibleSymbolAt(ltReelPos);
                (<LTSymbol>LtsymData.positionable).getStateAnimation(SymbolStates.REMOVED);
            }

            let anyXfeature: boolean = false;
            if (XwaysHoarder2.model.stopReels[5].includes("XN") || XwaysHoarder2.model.stopReels[5].includes("XS") || XwaysHoarder2.model.stopReels[5].includes("XW") || XwaysHoarder2.model.stopReels[5].includes("SC")) {
                anyXfeature = true;
            }
            gsap.delayedCall(anyXfeature ? 0.4 : 0.05, () => { // get landing animations under 5frames and reduce the delay
                controller.setSkipCallback();
                controller.finish();
            });

        }
    }

    private checkReelIsStacked(reelNo: number): boolean {
        let count: number = 0;
        XwaysHoarder2Statics.previousReelsAfterCollapse[reelNo].forEach((symName: string) => {
            if (symName === "XW" || symName === "XS" || symName === "SC" || symName === "SSC" || symName === "LTX") {
                count++
            }
        })
        return count == 3;
    }


}